const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusChangeRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M620.544 137.6c103.936 10.432 187.328 72.96 205.12 180.224h-60.16l97.088 144.448 97.152-144.448h-67.008C874.944 173.376 765.568 79.488 627.392 66.112c-19.136-1.536-36.864 14.848-36.864 35.712 1.28 17.92 13.568 34.24 30.016 35.776Zm-150.4-73.024H132.416c-19.136 0-34.176 16.384-34.176 37.248v321.728c0 20.864 15.04 37.248 34.176 37.248h337.728c19.136 0 34.176-16.384 34.176-37.248V101.824c0-20.864-15.04-37.248-34.176-37.248Zm-32.832 324.736H165.248V136.064h272.128v253.248h-.064ZM404.48 883.84c-116.224-10.432-205.12-87.872-209.216-216h64.256l-97.024-144.448L65.408 667.84h64.256c2.688 165.376 118.912 272.576 268.032 287.488 19.136 1.472 36.928-14.912 36.928-35.776.243-17.669-12.685-32.985-30.144-35.712Zm489.6-323.264H556.288c-19.2 0-34.176 16.448-34.176 37.248v323.264c0 20.8 14.976 37.184 34.176 37.184h337.728c19.136 0 34.112-16.384 34.112-37.184V597.824c.064-20.8-16.32-37.248-34.048-37.248Zm-32.896 324.736H589.12V633.536h272.064v251.776Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "matrix(.0246 0 0 .0246 -.609 -.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.073 341.793c-5.857-5.858-15.355-5.858-21.213 0l-29.56 29.56-29.56-29.56c-5.857-5.858-15.355-5.857-21.213 0-5.858 5.857-5.858 15.355 0 21.213l29.56 29.56-29.56 29.56c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.857 15.355 5.858 21.213 0l29.56-29.56 29.56 29.56c5.857 5.858 15.355 5.858 21.213 0 5.858-5.857 5.858-15.355 0-21.213l-29.56-29.56 29.56-29.56c5.859-5.858 5.859-15.355 0-21.213Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "translate(-6.005 -9.514) scale(.03914)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.054 447.267c-4.887 4.916-11.555 7.659-18.482 7.659-6.926 0-13.594-2.743-18.482-7.659L11.488 299.641c-15.317-15.317-15.317-40.156 0-55.445l18.482-18.487c15.323-15.318 40.133-15.318 55.451 0l92.151 92.156L426.578 68.854c15.323-15.318 40.157-15.318 55.451 0l18.482 18.487c15.317 15.318 15.317 40.152 0 55.446l-304.457 304.48Z",
    style: {
      fill: "#d73a1f",
      fillRule: "nonzero"
    },
    transform: "translate(14.646 15.393) scale(.01048)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusChangeRed);
export default __webpack_public_path__ + "static/media/status-change-red.4d82ab027d233814894338a6e81837e2.svg";
export { ForwardRef as ReactComponent };